// GraphVisualization.js
const buildCytoscapeElements = (csvData, selectedColumns) => {
  const elements = [];
  const uniqueIds = new Set();

  // Create nodes and edges
  csvData.forEach((row, i) => {
    // Extract values for source node, target node, and edge label
    const sourceId = row[selectedColumns[0]] || '';   // Use empty string if undefined
    const targetId = row[selectedColumns[1]] || '';   // Use empty string if undefined
    const edgeLabel = row[selectedColumns[2]] || '';  // Use empty string if undefined

    //console.log(sourceId)
    //console.log(targetId)
    //console.log(edgeLabel)
    // Check if sourceId and targetId are defined and not empty
    if (sourceId && targetId) {
      uniqueIds.add(sourceId);
      uniqueIds.add(targetId);

      // Create nodes
      elements.push({ data: { id: sourceId, label: sourceId } });
      elements.push({ data: { id: targetId, label: targetId } });

      // Create edges
      const edgeId = `${sourceId}-${targetId}`;
      elements.push({
        data: {
          id: edgeId,
          source: sourceId,
          target: targetId,
          label: edgeLabel || `Edge ${i + 1}`,  // Fallback label if edgeLabel is not provided
        },
      });
    }
  });

  return elements;
};

export default buildCytoscapeElements;